import { ALL_EQUIPMENTS } from '../../../shared/types/oeeRow.ts';
import { EquipmentGraph } from '../../components/equipment-oee-graph/equipmentGraph.tsx';
import { LiveGraphControls } from '../../components/live-graph-settings/liveGraphControls.tsx';
import { useDisplayOptions } from '../../components/live-graph-settings/useLiveGraphSettings.ts';
import { NavBar } from '../../components/navBar.tsx';
import { PageTitle } from '../../components/pageTitle.tsx';
import { useEquipmentGrid } from '../../hooks/useEquipmentGrid.ts';
import { useFullScreenToggle } from '../../hooks/useFullscreenToggle.ts';
import { usePageDisplay } from '../../hooks/usePageDisplay.ts';
import { FactoryGraph } from './factoryGraph.tsx';
import { HoursGraph } from './hoursGraph.tsx';
import { useFetchOees } from './useFetchOees.ts';


export function LiveGraphs() {
    const { isFullscreen } = useFullScreenToggle();

    return (
        <div style={{ height: '100vh', display: 'flex', flexDirection: 'column' }}>
            <PageTitle title='Live Graphs' />
            {!isFullscreen && <NavBar />}
            <div className='content' style={{ flex: '1 1', marginTop: 0 }}>
                <LiveGraphsContent />
            </div>
        </div>
    );
}

function LiveGraphsContent() {
    const { dataAll, dataPerEquipment } = useFetchOees();
    const { settings, setSettings } = useDisplayOptions();
    const { page } = usePageDisplay({ pageDisplay: settings.pageDisplay });

    const isSingleView = settings.pageDisplay?.key === 'single';
    const grid = useEquipmentGrid({ page, isSingleView });

    const liveDataAllEquipmentsRows = dataPerEquipment?.get(ALL_EQUIPMENTS);


    if (!dataAll || !dataPerEquipment) return 'Loading...';
    return (
        <div className='live-graphs__root'>
            <div className='live-graphs__settings_bar'>
                <LiveGraphControls settings={settings} setSettings={setSettings} />
            </div>

            <div className='live-graphs__top_bar'>
                <HoursGraph
                    className='live-graphs__top_bar_item'
                    shiftTable={dataAll?.shiftTable ?? []}
                    liveTable={dataAll?.liveTable ?? []}
                    displayOptions={settings}
                />
                <EquipmentGraph
                    className='live-graphs__top_bar_item'
                    equipment={ALL_EQUIPMENTS}
                    equipmentDisplayName={liveDataAllEquipmentsRows?.displayName ?? ''}
                    liveTableEquipment={liveDataAllEquipmentsRows?.liveTable ?? []}
                    hourTableEquipment={liveDataAllEquipmentsRows?.hourTable ?? []}
                    shiftTableEquipment={liveDataAllEquipmentsRows?.shiftTable ?? []}
                    displayOptions={settings}
                />
                <FactoryGraph
                    className='live-graphs__top_bar_item'
                    shiftTable={dataAll?.shiftTable ?? []}
                    graphValueType={settings.valueType!}
                    displayOptions={settings}
                />
            </div>

            <div
                className={`live-graphs__equipments equipment-grid${isSingleView ? ' equipment-grid--single' : ''}`}
                style={isSingleView ? {
                    gridTemplateColumns: `repeat(${grid.page2ColumnSpan}, minmax(0, 1fr)) 16px repeat(6, minmax(0, 1fr))`,
                } : undefined}
            >
                {isSingleView && <div className='live-graphs__page-separator' style={{ gridColumn: grid.separatorColumn }} />}

                {Array.from(dataPerEquipment.entries())
                    .filter(([equipment]) => equipment !== ALL_EQUIPMENTS)
                    .map(([equipment, data]) => {
                        const position = grid.getPosition(equipment);
                        if (!position) return null;

                        return (
                            <EquipmentGraph
                                key={equipment}
                                style={position}
                                equipment={equipment}
                                equipmentDisplayName={data.displayName}
                                liveTableEquipment={data.liveTable}
                                hourTableEquipment={data.hourTable}
                                shiftTableEquipment={data.shiftTable}
                                displayOptions={settings}
                            />
                        );
                    })}
            </div>
        </div>
    );
}
